const PrivacyPolicy = () => {
  return <>
    <link rel="stylesheet" href="css/BuyersGuide.moudle.css" />
    <div className="mkd-content">
      {/*SLIDER START*/}
      <div className="mkd-ps-image-holder">
        <div className="mkd-ps-image mkd-owl-slider">
          <div className="mkd-ps-image">
            <picture>
              <source media="(min-width: 481px)" srcSet="assets/banner-white.jpg" />
              <source media="(max-width: 480px)" srcSet="assets/banner-white-mobile.jpg" />
              <img
                className="d-block w-100"
                src="assets/banner-white-mobile.jpg"
                alt="Banner"
              />
            </picture>
          </div>
        </div>
      </div>
      {/*SLIDER END*/}

      <div className="vc_empty_space" style={{ height: 0 }}>
        <span className="vc_empty_space_inner" />
      </div>
      <section className="wpb-content-wrapper location-advantages">
        <div className="mkd-row-grid-section-wrapper ">
          <div className="mkd-row-grid-section">
            <div className="vc_row wpb_row vc_row-fluid vc_custom_1516021087353">
              <div className="wpb_column vc_column_container vc_col-sm-12">
                <div className="vc_column-inner vc_custom_1516007647796">
                  <div className="wpb_wrapper">
                    <div className="mkd-elements-holder   mkd-one-column  mkd-responsive-mode-768 ">
                      <div
                        className="mkd-eh-item    "
                        data-item-class="mkd-eh-custom-8773"
                        data-1280-1600="0 0 20px 0"
                        data-1024-1280="0 0 20px 0"
                        data-768-1024="0 0 20px 0"
                        data-680-768="0 0 20px 0"
                        data-680="0px"
                      >
                        <div className="mkd-eh-item-inner">
                          <div
                            className="mkd-eh-item-content mkd-eh-custom-8773"
                            style={{ padding: "0 0 20px 0" }}
                          >
                            <div className="mkd-section-title-holder  ">
                              <div className="mkd-st-inner road">
                                <h2 className="mkd-st-title">Grievance Redressal</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="mkd-content-inner">
        <div className="mkd-full-width">
          <div className="mkd-full-width-inner">
            <div className="mkd-grid-row">
              <div className="mkd-page-content-holder mkd-grid-col-12">
                <div className="mkd-row-grid-section-wrapper ">
                  <div className="mkd-row-grid-section">
                    <div className="vc_row wpb_row vc_row-fluid vc_custom_1516877211553 vc_column-gap-35">
                      <div className="wpb_column vc_column_container vc_col-sm-12">
                        <div className="vc_column-inner">
                          <div className="wpb_wrapper">
                            <div className="vc_row wpb_row vc_inner vc_row-fluid">
                              <div className="wpb_column vc_column_container vc_col-sm-12">
                                <div className="vc_column-inner">
                                  <div className="wpb_wrapper">
                                    <div className="wpb_text_column wpb_content_element ">
                                      <div className="wpb_wrapper">

                                        
                                        <p>
                                         Newry Properties is committed to upholding the highest standards of service and ensuring the provision of accurate and transparent information to all our valued customers and allottees through this website. 
                                         <br></br><br></br>
                                         <p>For any complaints, concerns, or queries, kindly reach out to us using the email ID provided below.</p>
                                        
                                          <p>
                                            <b>
                                              📧 <a href="mailto:escalations@newry.co.in">escalations@newry.co.in</a> (Chennai)
                                            </b>
                                          </p>

                                          <p>For Escalations and Serious Concerns, kindly reach out to the Promoter's Family Office, Hong Kong using the email ID provided below

                                          </p>

                                          <p> <b>
                                              📧 <a href="mailto:escalations@newry.com.hk">escalations@newry.com.hk</a> (HK)
                                            </b></p>
                                        </p>
                                        <br />
                                        <div className="wpb_text_column wpb_content_element ">
                                          <div className="wpb_wrapper">
                                            <p style={{ color: "#2c498a", fontWeight: "bold", textTransform: "uppercase" }}>
                                              Please write the email in the given format:
                                            </p>

                                          </div>
                                        </div>

                                        <div class="grievance-details">
                                          <p>👤 <strong>Name :</strong></p>
                                          <p>📞 <strong>Contact No. :</strong></p>
                                          <p>🏢 <strong>Project Name :</strong></p>
                                          <p>🏠 <strong>Unit No. (or) Plot No. :</strong></p>
                                          <p>📝 <strong>Grievance :</strong></p>
                                        </div>
                                        <br />

                                      </div>
                                    </div>
                                    <div
                                      className="vc_empty_space"
                                      style={{ height: 32 }}
                                    >
                                      <span className="vc_empty_space_inner" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </>;
}

export default PrivacyPolicy;